import React from 'react';

import { Enterprise } from 'apis/enterprise/types';

export type EnterpriseContextValue = {
  enterprise: Enterprise | undefined;
};

export const EnterpriseContext = React.createContext<EnterpriseContextValue>({
  enterprise: undefined,
});

export const useEnterpriseContext = () => {
  const enterpriseContext = React.useContext(EnterpriseContext);
  return enterpriseContext;
};

export const EnterpriseContextProvider = EnterpriseContext.Provider;
